import dayjs from 'dayjs';
import { Controller } from 'stimulus';

// Listen to presentation download click event and do an optimistic update of the downloaded_at column in
// the presentation table, so it shows the last time the presentation was downloaded in the index page.
export default class extends Controller {
  connect() {
    this.element.addEventListener('click', this.handleDownloadClick);
  }

  disconnect() {
    this.element.removeEventListener('click', this.handleDownloadClick);
  }

  handleDownloadClick = (event) => {
    const link = event.target.closest('.btn_download[data-download-presentation]');

    if (link == null || !this.element.contains(link)) {
      return;
    }

    const { downloadPresentation: presentationId } = link.dataset;

    if (presentationId == null) {
      return;
    }

    const downloadedElement = this.element.querySelector(`.presentation-downloaded-at-${presentationId}`);

    if (downloadedElement) {
      downloadedElement.textContent = dayjs().format('DD/MM/YYYY HH:mm [hs]');
    }
  };
}
